import React from 'react';
import { Flex, Text, Box } from 'rebass/styled-components';
import { Button } from '@getro/rombo';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import PropTypes from 'prop-types';

export const NetworkAdminOnboardingLinkedinSyncActive = ({ handleNextStep, activeNetwork }) => (
  <Flex sx={{ flexDirection: 'column', alignItems: 'center', gap: '32px' }}>
    <Flex flexDirection="column" sx={{ gap: '24px' }}>
      <Text color="text.dark" fontWeight="600" fontSize="18px">
        LinkedIn connected!
      </Text>
      <Flex
        sx={{
          flexDirection: 'column',
          gap: '16px',
          fontWeight: '400',
          fontSize: '16px',
          lineHeight: '20px',
          color: 'text.main',
        }}
      >
        <Text color="text.main">We’re syncing your contacts now—this may take up to 10 minutes to complete.</Text>
        <Flex sx={{ gap: '16px', bg: 'neutral.20', p: '16px' }}>
          <Box>💡</Box>
          <Flex sx={{ flexDirection: 'column', gap: '8px', fontWeight: '500', fontSize: '14px', lineHeight: '20px' }}>
            <Text>Who can see your contacts?</Text>
            <Text>
              Admins of {activeNetwork?.name} can now see your contacts. You can choose to share them with other
              networks when invited.
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Button
        as={Link}
        onClick={() => handleNextStep('linkedin-sync')}
        size="medium"
        variant="primary"
        sx={{ width: '100%', justifyContent: 'center' }}
        icon={ChevronRight}
        iconPosition="right"
      >
        Continue
      </Button>
    </Flex>
  </Flex>
);

NetworkAdminOnboardingLinkedinSyncActive.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  activeNetwork: PropTypes.object.isRequired,
};
